<script lang="ts" setup>
  import { generateReceipt } from '@/modules/employees/services/ReceiptService'
  import utc from 'dayjs/plugin/utc'
  import dayjs from 'dayjs'
  import { ref, onMounted } from 'vue'
  dayjs.extend(utc)

  const props = defineProps<{
    items: {
      id: string
      closedPayrollId: string
      employeeId: string
      startDate: string
      endDate: string
      processType: string
      isVisible: boolean
    }
  }>()

  const isLoading = ref(false)

  const onPrintReceipt = async (
    employeeId: string,
    closedPayrollId: string
  ) => {
    isLoading.value = true
    let receiptInBuffer = await generateReceipt({
      employeeId,
      closedId: closedPayrollId,
    })

    isLoading.value = false
    if (!receiptInBuffer) return
    const url = window.URL.createObjectURL(receiptInBuffer)
    const link = document.createElement('a')
    link.href = url
    link.download = `receipt_${closedPayrollId}.pdf`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  }
</script>
<template>
  <div class="surface-card border-round-xl shadow-2 p-4 mt-3">
    <div class="flex flex-column justify-content-between mb-3">
      <div class="flex align-items-center mb-3">
        <i class="pi pi-calendar text-500 mr-2"></i>
        <span class="text-500 text-sm">Proceso: {{ items.processType }}</span>
      </div>
      <div class="flex align-items-center">
        <div>
          <h6 class="font-semibold text-primary mb-1 text-sm">
            Recibo de Pago
          </h6>
          <p class="text-600 text-sm m-0">
            Período: {{ dayjs(items.startDate).utc().format('YYYY-MM-DD') }} -
            {{ dayjs(items.endDate).utc().format('YYYY-MM-DD') }}
          </p>
        </div>
        <Button
          label=""
          icon="pi pi-download"
          class="p-button-sm p-button-secondary font-light ml-3"
          @click="onPrintReceipt(items.employeeId, items.closedPayrollId)"
          :disabled="!items.id"
          :loading="isLoading"
        />
      </div>
    </div>
  </div>
</template>
<style scoped>
  .surface-card {
    transition: all 0.3s ease;
  }

  .surface-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
  }

  .text-xl {
    font-size: 1.25rem;
  }
</style>
